import { elexity } from '../utilities/SolarTrendsGraphHelper';
import { SOLAR_SERIES_DATA } from '../config/solar-series';

////GRAPHS////
function graphPieTotals(data, fromTime, toTime, callback) {
  let tempData = data.entries;
  let payload;

  const gridIndex = data.seriesNames.indexOf(SOLAR_SERIES_DATA.GRID_CONSUMED);
  const solarConsumedIndex = data.seriesNames.indexOf(SOLAR_SERIES_DATA.SOLAR_CONSUMED);
  const solarExportedIndex = data.seriesNames.indexOf(SOLAR_SERIES_DATA.SOLAR_POWER_EXPORTED);

  let tempGridTotal = 0;
  let tempSolarConsumedTotal = 0;
  let tempSolarExportedTotal = 0;

  for (let i = 0; i < tempData.length; i++) {
    let tempTime = tempData[i].timestamp;

    if (tempTime >= fromTime.value.start && tempTime <= toTime.value.start) {
      if (gridIndex > -1) {
        tempGridTotal = tempGridTotal + tempData[i].values[gridIndex];
      }
      if (solarConsumedIndex > -1) {
        tempSolarConsumedTotal = tempSolarConsumedTotal + tempData[i].values[solarConsumedIndex];
      }
      if (solarExportedIndex > -1) {
        tempSolarExportedTotal = tempSolarExportedTotal + tempData[i].values[solarExportedIndex];
      }
    }
  }

  payload = {
    gridTotal: tempGridTotal,
    solarConsumedTotal: tempSolarConsumedTotal,
    solarExportedTotal: tempSolarExportedTotal,
  };

  if (callback !== null) {
    callback(payload);
  }
}

const mapPosixToIANA = (posixCode) => {
  switch (posixCode.toLowerCase()) {
    case 'pst8pdt':
      // Pacific Time (US/Canada DST rules)
      return 'America/Los_Angeles';
    case 'mst7mdt':
      // Mountain Time (US/Canada DST rules)
      return 'America/Denver';
    case 'cst6cdt':
      // Central Time (US/Canada DST rules)
      return 'America/Chicago';
    case 'est5edt':
      // Eastern Time (US/Canada DST rules)
      return 'America/New_York';
    case 'akst9akdt':
      // Alaska Time
      return 'America/Anchorage';
    case 'hst10':
      // Hawaii Time (No DST)
      return 'Pacific/Honolulu';
    default:
      // console.error(`Timezone code ${posixCode} is unrecognized. Treating as IANA code.`);
      return posixCode;
  }
};

export { graphPieTotals, mapPosixToIANA };
